<template>

  <div class="card m-3" style="width: 18rem;">
    <div>
      <img v-if="thumbnail" @click="viewTicketDetails" width="200px" height="180px" :src="thumbnail" :id="`thumbnail${ticket.id}`" class="card-img-top"
        alt="...">
      <p v-else>Loading image...</p>
      <div class="dropdown options">
        <button class="btn optionsButton" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
          data-bs-target="dropdownMenuButton1" aria-expanded="false">
          <i class="bi bi-three-dots"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li v-b-tooltip.hover
            :title="!canDeleteTicket() ? manageStore.lang('cards.modelcard.options.delete_hint') : ''">
            <button :disabled="!canDeleteTicket()" @click="removeTicket" class="dropdown-item">{{
              manageStore.lang("cards.modelcard.options.delete_ticket") }}</button>

          </li>
        </ul>
      </div>
    </div>


    <div class="card-body bg-primary3">
      <h4 @click="viewTicketDetails" class="card-title fs-5 text-white fw-bold">
        {{ ticket.ticket_name }}
      </h4>
      <div class="d-flex justify-content-evenly align-items-center mt-4 py-2">
        <img class="rounded-circle" width="40rem"
          :src="ticket.assignee == undefined || ticket.assignee == '' ? 'default-profile.png' : manageStore.baseUserImageUrl + ticket.assignee"
          alt="printer profile">
        <!-- <i class="fi fi-rr-angle-double-small-up fs-4 text-danger"></i> -->
        <div class="rounded border border-primary2 border-2" style="width: 45px;">
          <img v-if="ticket.priority == 1" src="../../assets/svg/priority_low.svg" width="25px" alt="">
          <img v-if="ticket.priority == 2" src="../../assets/svg/priority_medium.svg" width="25px" alt="">
          <img v-if="ticket.priority == 3" src="../../assets/svg/priority_high.svg" width="25px" alt="">
        </div>
        <div class="'w-50" v-b-tooltip.hover :title="statusTooltip">
          <button @click="setAssigningTicket" :disabled="canSetTicketToPrinted()" v-b-tooltip.hover
            :class="'btn text-white fw-bold bg-status' + ticket.status">
            {{ ticketStore.getStateName(ticket) }}
          </button>
        </div>

      </div>
    </div>
  </div>

</template>

<script setup>
import { PrintingTicket } from "../../other/DataStructs.ts"
import { useTicketsStore } from '@/stores/tickets.ts';
import { useManageStore } from '@/stores/manage';
import { useAuthStore } from '@/stores/authStore.ts';
import { onMounted, ref, defineProps } from "vue";

const props = defineProps({
  ticket: PrintingTicket
})

const ticketStore = useTicketsStore();
const manageStore = useManageStore();
const authStore = useAuthStore();

const thumbnail = ref(null);

onMounted(async () => {
  thumbnail.value = await ticketStore.fetchTicketImage(props.ticket.id);
});

function canDeleteTicket() {
  return (authStore.preferred_username == props.ticket.client && props.ticket.status == 1) || authStore.user_role == authStore.userRoles[1];
}

function viewTicketDetails() {
  manageStore.loadDialog("EditTicketModal", Object.assign({}, props.ticket));
}

function setAssigningTicket() {
  let state;
  try {
    state = ticketStore.states[0].id;
  }
  catch (e) {
    state = "";
  }
  if (props.ticket.status == state) {
    manageStore.loadDialog("AssigneeModal", Object.assign({}, props.ticket));
  }
  else {
    manageStore.loadDialog("AssignOptionsModal", Object.assign({}, props.ticket));
  }
  authStore.fetchAllPrinterUsers();
}

function canSetTicketToPrinted() {

  let startState;
  try {
    startState = ticketStore.states[0].id;
  }
  catch (e) {
    startState = "";
  }

  if (props.ticket.status == startState) {
    return authStore.user_role != authStore.userRoles[1];
  }
  else {
    return authStore.user_role != authStore.userRoles[1];
  }

}
function statusTooltip() {
  let text = "";

  let state;
  try {
    state = ticketStore.states[0].id;
  }
  catch (e) {
    state = "";
  }

  if (canSetTicketToPrinted()) {
    if (props.ticket.status == state) {
      text = manageStore.lang("cards.modelcard.tooltips.assignTicket");
    }
    else {
      text = manageStore.lang("cards.modelcard.tooltips.setPrinted");
    }
  }
  return text;
}

function removeTicket() {
  manageStore.loadDialog("removeTicketModal", Object.assign({}, props.ticket))
}
</script>

<style scoped>
.card-img-top,
.card-title {
  cursor: pointer;
}

.options {
  position: absolute;
  right: 0;
  top: 0;
}

.optionsButton {
  cursor: pointer;
  background-color: rgba(255, 255, 255);
  opacity: 60%;

}

.optionsButton:hover {
  opacity: 95%;
}

.iconbutton {
  cursor: pointer;
}

.btn.disabled {
  pointer-events: auto;
}
</style>